<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path fill-rule="evenodd" d="M19.716 28.166c4.93-1.784 8.451-6.483 8.451-12s-3.52-10.216-8.45-12v2.173c3.784 1.675 6.422 5.444 6.422 9.827s-2.639 8.152-6.423 9.827v2.173zm0-6.12a5.51 5.51 0 002.107-1.485 6.323 6.323 0 001.193-2.017 6.919 6.919 0 00.419-2.378c0-.816-.143-1.624-.42-2.379a6.324 6.324 0 00-1.192-2.016 5.51 5.51 0 00-2.107-1.484v11.758zM5.604 20.533h4.035l6.209 6.02c.42.409 1.164.132 1.164-.433V6.043c0-.566-.743-.843-1.165-.434L9.64 11.63H5.604c-.794 0-1.437.57-1.437 1.272v6.36c0 .702.643 1.271 1.437 1.271z" clip-rule="evenodd"/></svg>
</template>

<script>
export default {
  name: 'mediaVolumeOnFilled'
}
</script>
